/* AUDIO BUTTON */
// ---------------- AUDIO BUTTON MODULE ----------------
import { Countdown } from "./countdown";
declare global {
  interface Window {
    statusPermits: any;
    btnNew: any;
  }
}
export const AudioButton = (function () {
  interface Music {
    container: string;
    audioSelector: string;
    muted?: boolean;
    btnSelector: string;
  }

  let backAudio: Music = {
    container: "audio-container",
    audioSelector: "src",
    btnSelector: "button",
  };

  function _addButtonEvent(btnElement: HTMLButtonElement): void {
    let { container, btnSelector } = backAudio;

    btnElement.addEventListener("click", () => {
      let { audioBtn: dataButton } = btnElement.dataset;
      let arrAudioSrc = dataButton.split(",");
      let audioSrcList = _searchAudioSource(arrAudioSrc);
      if (audioSrcList.length > 0) {
        for (let i = 0; i < audioSrcList.length; i++) {
          const audioSrc: HTMLAudioElement = audioSrcList[i];
          audioSrc.muted = !audioSrc.muted;
          let validClass = btnElement.classList.contains(
            "audio-container__button--disabled"
          );
          if (validClass) {
            btnElement.classList.remove(`audio-container__button--disabled`);
            Countdown._setAudio("playPermits");
          }
          if (audioSrc.muted) {
            btnElement.classList.add(`${container}__${btnSelector}--disabled`);
            Countdown._setAudio("stopPermits");
          } else {
            btnElement.classList.remove(
              `${container}__${btnSelector}--disabled`
            );
            Countdown._setAudio("playPermits");
          }
        }
      }
    });
  }

  function _searchAudioSource(
    arrAudioSrc: Array<String>
  ): Array<HTMLAudioElement> {
    let refAudioSrc: Array<HTMLAudioElement> = [];
    for (let i = 0; i < arrAudioSrc.length; i++) {
      const audioSrc = arrAudioSrc[i];

      refAudioSrc.push(
        document.querySelector(`audio[data-audio-src=${audioSrc}]`)
      );
    }
    return refAudioSrc.filter((audio) => audio != null);
  }

  function init() {
    let { container } = backAudio;
    let refAudioButton: NodeListOf<HTMLButtonElement> =
      document.querySelectorAll(`.${container} button[data-audio-btn]`);

    if (refAudioButton.length > 0) {
      for (let i = 0; i < refAudioButton.length; i++) {
        const audioBtn = refAudioButton[i];
        _addButtonEvent(audioBtn);
      }
    }
  }

  return { init };
})();
